import shortid from "shortid";
import { formatDate } from "../../../utils";
import {
  calcularValores,
  converterData,
  converterNumero,
  converterTexto,
  validarTitulo,
} from "../importar-titulos";

export class TituloPagar {
  id = null;
  linha = null;
  numeroTitulo = null;
  origem = null;
  pessoaId = null;
  pessoaNome = null;
  historico = null;
  dataLancamento = null;
  dataVencimento = null;
  dataCompetencia = null;
  meioPagamentoId = null;
  meioPagamentoDescricao = null;
  bancoCaixaId = null;
  valor = null;
  acrescimo = null;
  desconto = null;
  valorTotal = null;
  erros = {};

  constructor(linha, cadastros) {
    this.id = shortid.generate();
    this.linha = linha.linha;
    this.numeroTitulo = converterTexto(linha.numeroTitulo);
    this.origem = converterTexto(linha.origem) || "EXPORTADO";
    this.historico = converterTexto(linha.historico);
    this.dataLancamento = converterData(linha.dataLancamento);
    this.dataVencimento = converterData(linha.dataVencimento);
    this.setDataCompetencia(linha.dataCompetencia);
    Object.assign(
      this,
      calcularValores(
        converterNumero(linha.valor),
        converterNumero(linha.valorTotal),
      ),
    );
    this.setFornecedor(converterNumero(linha.pessoaId), cadastros.pessoas);
    this.setMeioPagamento(
      converterNumero(linha.meioPagamentoId),
      cadastros.meiosPagamento,
    );
    validarTitulo(this);
  }

  setDataCompetencia(dataCompetencia) {
    if (converterTexto(dataCompetencia)) {
      this.dataCompetencia = converterData(dataCompetencia);
      if (!this.dataCompetencia) {
        this.erros.dataCompetencia = "Data de Competência inválida";
      }
    } else {
      this.dataCompetencia = this.dataLancamento;
    }
  }

  setFornecedor(pessoaId, pessoas) {
    const fornecedor = pessoas.find(({ id }) => id === pessoaId);
    this.pessoaId = pessoaId;
    this.pessoaNome = fornecedor?.nomeRazaoSocial;
    if (!fornecedor) {
      this.erros.pessoaId = pessoaId
        ? "Fornecedor não encontrado no cadastro"
        : "Fornecedor não informado";
    }
  }

  setMeioPagamento(meioPagamentoId, meiosPagamento) {
    const meioPagamento = meiosPagamento.find(
      ({ id }) => id === meioPagamentoId,
    );
    this.meioPagamentoId = meioPagamentoId;
    this.meioPagamentoDescricao = meioPagamento?.descricao;
    this.bancoCaixaId = meioPagamento?.bancoCaixaId;
    if (!meioPagamento) {
      this.erros.meioPagamentoId = meioPagamentoId
        ? "Meio de Pagamento não encontrado no cadastro"
        : "Meio de Pagamento não informado";
    }
  }

  dadosImportacao() {
    return {
      numeroTitulo: this.numeroTitulo,
      origem: this.origem,
      pessoaId: this.pessoaId,
      historico: this.historico,
      dataLancamento: formatDate.toSend(this.dataLancamento),
      dataVencimento: formatDate.toSend(this.dataVencimento),
      dataCompetencia: formatDate.toSend(this.dataCompetencia),
      meioPagamentoId: this.meioPagamentoId,
      bancoCaixaId: this.bancoCaixaId,
      valor: this.valor,
      acrescimo: this.acrescimo,
      desconto: this.desconto,
    };
  }
}
